<template>
  <div class="features-area pt-100 pb-75">
    <div class="container mw-1356">
      <div
        class="section-title mw-860 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">لماذا نحن؟</span>
        <h2>ما الذي يجعلنا خيارك الأفضل والفريد؟</h2>
      </div>
      <div class="row justify-content-center">
        <div
          v-for="(feature, index) in features"
          :key="index"
          class="col-xl-4 col-md-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="200 + index * 100"
        >
          <div
            class="features-single-item position-relative hover-style1 style-two"
          >
            <div class="hover-style2">
              <i :class="feature.icon" class="icon"></i>
              <h3>
                <a href="https://wa.me/447429916178" target="_blank">
                  {{ feature.title }}
                </a>
              </h3>
              <p class="text-silver">{{ feature.description }}</p>
              <a href="https://wa.me/447429916178" target="_blank" class="read-more style-two">
                {{ feature.buttonText }}
                <i class="ti ti-arrow-right"></i>
              </a>
              <span class="count">{{ index + 1 }}</span>
            </div>
            <img
              src="@/assets/images/features-shape.png"
              class="features-shape"
              alt="features-shape"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "WhatMakesUsDifferent",
  setup() {
    const features = ref([
      {
        icon: "flaticon-tv",
        title: "ثبات كامل وبدون تقطيع",
        description:
          "استمتع بمتابعة أقوى المباريات العالمية والأحداث الرياضية الكبرى وحفلات الـ PPV مباشرة دون أي رمشة أو بطء بفضل السيرفرات المخصصة عالية الكفاءة.",
        buttonText: "اشترك الآن",
      },
      {
        icon: "flaticon-content-marketing",
        title: "تحديثات يومية للمحتوى",
        description:
          "مكتبة ضخمة ومتجددة على مدار الساعة تضم أحدث الأفلام السينمائية، والمسلسلات الحصرية من منصات العرض العالمية مع ترجمة احترافية كاملة.",
        buttonText: "تصفح الباقات",
      },
      {
        icon: "flaticon-smartphone",
        title: "دعم فني 24/7 متواصل",
        description:
          "فريق دعم فني متكامل معك في أي وقت لمساعدتك خطوة بخطوة في ضبط وتفعيل اشتراكك على الشاشات والهواتف الذكية وضمان أفضل تجربة مشاهدة.",
        buttonText: "تواصل معنا",
      },
    ]);

    return { features };
  },
});
</script>